import '../styles/Guess.css';

function GuessCharacter({rows, characterNow, nbTest}) {   

    console.log('rows', rows, 'characterNow', characterNow)


	return (
        
		<div className="guess">
            <div className="guess-container">
                <img 
                className = { nbTest === 0 ? 'img-character blur-0' 
                    : nbTest === 1 ? 'img-character blur-1'
                    : nbTest === 2 ? 'img-character blur-2'
                    : nbTest === 3 ? 'img-character blur-3'
                    : nbTest === 4 ? 'img-character blur-4'
                    : nbTest === 5 ? 'img-character blur-5'
                    : nbTest === 6 ? 'img-character blur-6'
                    : nbTest === 7 ? 'img-character blur-7'
                    : nbTest === 8 ? 'img-character blur-8'
                    : nbTest === 9 ? 'img-character blur-9'
                    :'img-character'
                }
                src={`/images/characters/${characterNow.image_personnage}`} alt={characterNow.image_personnage} />
            </div>
        </div>

	)
}

export default GuessCharacter
